import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

/** Stripe PRO checkout cancel -> back to /host-premium */
export default function ProCancelPage() {
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const eventId = sp.get('event_id') || '';

  useEffect(() => {
    const params = new URLSearchParams();
    if (eventId) params.set('event_id', eventId);
    navigate(`/host-premium?${params.toString()}`, { replace: true });
  }, [eventId, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen" data-testid="pro-cancel-redirect">
      <div className="w-8 h-8 border-2 border-[#146BFF] border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
